import { render, staticRenderFns } from "./DelhamentoRankingFornecedores.vue?vue&type=template&id=4ba3b806&scoped=true&"
import script from "./DelhamentoRankingFornecedores.vue?vue&type=script&lang=js&"
export * from "./DelhamentoRankingFornecedores.vue?vue&type=script&lang=js&"
import style0 from "./DelhamentoRankingFornecedores.vue?vue&type=style&index=0&id=4ba3b806&scoped=true&lang=css&"
import style1 from "./DelhamentoRankingFornecedores.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba3b806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
